// client/src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Checkout from "./pages/Checkout";
import ExamSession from "./pages/ExamSession";
import VerifyCertificate from "./pages/VerifyCertificate";
import ExamDetails from "./pages/ExamDetails";
import ExamCheck from "./pages/ExamCheck";
import AdminExamQuestions from "./pages/AdminExamQuestions";
import CourseGenAI from "./pages/CourseGenAI";
import CourseFullStack from "./pages/CourseFullStack";
import CourseCloud from "./pages/CourseCloud";
import CourseCyber from "./pages/CourseCyber";
import CourseNoCode from "./pages/CourseNoCode";
import CourseDataAI from "./pages/CourseDataAI";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refunds from "./pages/Refunds";


const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

// 💡 Public landing: if already logged in, redirect to dashboard/admin
function LandingOrRedirect() {
  const token = localStorage.getItem("token");
  const user = getUser();

  if (token && user?.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  if (token && user?.role === "user") {
    return <Navigate to="/dashboard?tab=available" replace />;
  }

  // not logged in → show login/landing page
  return <Login />;
}

// 🔐 Wrapper for protected routes
const RequireAuth = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const user = getUser();

  // no token → send to landing
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // role-based protection
  if (allowedRoles && allowedRoles.length > 0) {
    if (!user?.role || !allowedRoles.includes(user.role)) {
      // if logged in but wrong role → send to normal dashboard
      return <Navigate to="/dashboard?tab=available" replace />;
    }
  }

  return children;
};

// Redirect logged-in users away from auth pages (login)
const RedirectIfLoggedIn = ({ children }) => {
  const token = localStorage.getItem("token");
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC: Landing / Login (redirect to dashboard when logged in) */}
        <Route
          path="/"
          element={
            <RedirectIfLoggedIn>
              <Login />
            </RedirectIfLoggedIn>
          }
        />

        {/* PUBLIC: Certificate verification */}
        <Route path="/verify" element={<VerifyCertificate />} />

        {/* USER: Dashboard */}
        <Route
          path="/dashboard"
          element={
            <RequireAuth allowedRoles={["user", "admin"]}>
              <Dashboard />
            </RequireAuth>
          }
        />

        {/* ADMIN: Dashboard */}
        <Route
          path="/admin"
          element={
            <RequireAuth allowedRoles={["admin"]}>
              <AdminDashboard />
            </RequireAuth>
          }
        />



        <Route
  path="/admin/exams/:examId/questions"
  element={
    <RequireAuth allowedRoles={["admin"]}>
      <AdminExamQuestions />
    </RequireAuth>
  }
/>

        {/* USER: Checkout */}
        <Route
          path="/checkout/:id"
          element={
            <RequireAuth allowedRoles={["user"]}>
              <Checkout />
            </RequireAuth>
          }
        />

        {/* Exam details + checkout */}
        <Route
          path="/exam/:id"
          element={
            <RequireAuth allowedRoles={["user"]}>
              <ExamDetails />
            </RequireAuth>
          }
        />

        {/* USER: Exam session */}
        {/* USER: Exam pre-check */}
        <Route
          path="/exam-check/:attemptId"
          element={
            <RequireAuth allowedRoles={["user"]}>
              <ExamCheck />
            </RequireAuth>
          }
        />

        <Route
          path="/exam-session/:attemptId"
          element={
            <RequireAuth allowedRoles={["user"]}>
              <ExamSession />
            </RequireAuth>
          }
        />
        <Route path="/course/genai" element={<CourseGenAI />} />
<Route path="/course/fullstack" element={<CourseFullStack />} />
<Route path="/course/cloud" element={<CourseCloud />} />
<Route path="/course/cyber" element={<CourseCyber />} />
<Route path="/course/nocode" element={<CourseNoCode />} />
<Route path="/course/dataai" element={<CourseDataAI />} />
<Route path="/terms" element={<Terms />} />
<Route path="/privacy" element={<Privacy />} />
<Route path="/refunds" element={<Refunds />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
